/* src/pages/ComputerRepair.js */

import React, { useEffect } from "react";
import PageSection from "../components/PageSection";
import { Helmet } from "react-helmet";
import styles from "./Pages.module.css"; // CSS Module
import computerRepairImage from "../assets/Images/computer-repair.jpg";
import { Link } from "react-router-dom";

function ComputerRepair() {
  useEffect(() => {
    // Add structured data for this service
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Computer Repair",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Tharpe Industries"
      },
      "areaServed": {
        "@type": "City",
        "name": "Shreveport-Bossier"
      },
      "description": "Fast and reliable computer repair services for businesses in Shreveport-Bossier."
    });
    document.head.appendChild(script);

    // Clean up function to remove the script when component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  const faqs = [
    {
      question: "What types of computer issues do you handle in Shreveport?",
      answer:
        "I handle a wide range of issues including hardware failures, software glitches, virus removal, data recovery, screen replacements, and system optimizations for both Windows and Mac computers. I service all major brands including Dell, HP, Lenovo, Apple, ASUS, and custom-built systems.",
    },
    {
      question: "How quickly can you repair my computer in Shreveport-Bossier?",
      answer:
        "I prioritize urgent repairs and strive to resolve most issues within 24-48 hours, depending on the complexity. For businesses with service agreements, I offer same-day emergency service to minimize downtime.",
    },
    {
      question: "Do you offer on-site computer repair services in Shreveport?",
      answer:
        "Yes, I provide both in-shop and on-site computer repair services throughout Shreveport and Bossier City. I can come to your home or business to diagnose and fix issues without you having to disconnect and transport your equipment.",
    },
    {
      question: "What are your computer repair rates in Shreveport?",
      answer:
        "My computer repair services in Shreveport start at $75 for diagnostics, with most common repairs ranging from $100-$250 depending on complexity. I provide free estimates before beginning any work and offer competitive rates compared to other IT service providers in the Shreveport-Bossier area.",
    },
    {
      question: "Do you offer warranties on your computer repairs?",
      answer:
        "Yes, I provide a 90-day warranty on all repair services in Shreveport, ensuring peace of mind and reliability. If the same issue recurs within the warranty period, I'll fix it at no additional cost.",
    },
  ];

  return (
    <PageSection title="Computer Repair Services in Shreveport-Bossier" cta faqs={faqs}>
      <Helmet>
        <title>Computer Repair Shreveport | Fast & Affordable PC & Mac Repair | Tharpe Industries</title>
        <meta
          name="description"
          content="Expert computer repair services in Shreveport-Bossier. Fast, affordable fixes for PC, Mac, laptop & desktop issues. Virus removal, hardware repair, data recovery & more. Same-day service available."
        />
        <meta
          name="keywords"
          content="computer repair Shreveport, PC repair Bossier City, laptop repair Shreveport, virus removal Shreveport, data recovery Shreveport, computer fix near me, affordable computer repair, business IT support Shreveport"
        />
        <link rel="canonical" href="https://tharpeindustries.com/computer-repair" />
      </Helmet>
      <div className={styles.contentContainerReverse}>
        <img
          src={computerRepairImage}
          alt="Computer Repair Services in Shreveport"
          className={styles.pageImage}
          loading="lazy"
        />
        <div className={styles.textContent}>
          <h2>Computer Broken? I'll Fix It.</h2>
          <p>
            Whether it's a virus, a cracked screen, or just running slower than molasses - I can help. 
            I've been fixing computers in Shreveport-Bossier for over 10 years, and I keep things simple: 
            you tell me what's wrong, I figure out the problem, fix it, and explain what happened in plain English.
          </p>
          
          <h3>What I Fix:</h3>
          <ul>
            <li>Virus and malware removal</li>
            <li>Hardware repairs (screens, keyboards, power issues)</li>
            <li>Data recovery from dead drives</li>
            <li>Slow computer tune-ups</li>
            <li>Windows and Mac problems</li>
            <li>Network and WiFi issues</li>
          </ul>
          
          <h3>How It Works:</h3>
          <ul>
            <li><strong>Call or text me</strong> - No automated phone menus</li>
            <li><strong>Free estimate</strong> - I tell you the cost before starting work</li>
            <li><strong>Fast turnaround</strong> - Most repairs done in 24-48 hours</li>
            <li><strong>90-day warranty</strong> - If the same problem comes back, I'll fix it free</li>
          </ul>
          
          <p>
            I work on all brands: Dell, HP, Lenovo, Apple, ASUS, Acer, Microsoft Surface, and custom builds. 
            Serving Shreveport, Bossier City, Benton, and surrounding areas.
          </p>
        </div>
      </div>
    </PageSection>
  );
}

export default ComputerRepair;
